<template>
  <div
    class="creating relative flex w-fit items-center gap-x-1.5 text-[14px] leading-[18px]"
  >
    Creating report
    <slot>
      <span class="size-3.5" aria-hidden="true" />
    </slot>
  </div>
</template>

<style scoped>
.creating {
  background: linear-gradient(to right, #1bbedb, #ffa20b, #f84600, #db3199);
  background-size: 300% 300%;
  animation: cycle 6s ease infinite;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.creating::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(to right, #1bbedb, #ffa20b, #f84600, #db3199);
  background-size: 300% 300%;
  animation: cycle 6s ease infinite;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cg transform='translate(.75 .75)' fill='none' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5.25 7.524v-2.05H4.145'/%3E%3Crect width='10.5' height='10.5' rx='3'/%3E%3Ccircle cx='5.25' cy='3.188' r='1' fill='white' stroke='none'/%3E%3C/g%3E%3C/svg%3E")
    no-repeat right center / 0.875rem;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cg transform='translate(.75 .75)' fill='none' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5.25 7.524v-2.05H4.145'/%3E%3Crect width='10.5' height='10.5' rx='3'/%3E%3Ccircle cx='5.25' cy='3.188' r='1' fill='white' stroke='none'/%3E%3C/g%3E%3C/svg%3E")
    no-repeat right center / 0.875rem;
}

@keyframes cycle {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
